import React from 'react';
import { Heading, View, colors, Button } from '@fairygodboss/ui';
import { GridColumnWrapper } from '../../../Events/EventLandingPage/components/GridColumnWrapper';
import {
    AboveTheFoldLgSVG,
    AboveTheFoldMdSVG,
    AboveTheFoldSmSVG,
} from './AboveTheFoldSVG';
import { useAdvicePage } from '../AdvicePageContext';
import { AuthWrapper } from '../../../../pages/HomePage_v2/sections/components/AuthWrapper';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

const AuthLoginButton = ({ onLoginPress }) => {
    return (
        <AuthWrapper
            component={
                <Button
                    onPress={onLoginPress}
                    width={{ _: '100%', sm: 'auto' }}
                    size="large"
                    mt="32px"
                >
                    Sign up for free
                </Button>
            }
            redirectUrl="/advice"
            loginTrigger="advice-hub-registration"
        />
    );
};

AuthLoginButton.displayName = 'AuthLoginButton';

export const AboveTheFold = () => {
    const { isLoggedIn } = useAdvicePage();

    const onLoginPress = () => {
        EmitMetric({
            misc_event_type: 'advice_a_button',
            misc_event_count: 1,
        });
    };
    return (
        <GridColumnWrapper
            color={colors.neutral[100]}
            backgroundColor={colors.info.light}
            gridAlignment={{ _: 'center', md: 'start' }}
            gridColumnSpacing={{ _: 12, sm: 9, md: 6, lg: 6 }}
            pt={{ _: '40px', sm: '345px', md: '64px' }}
            px={{ _: '16px', sm: '0px', md: '24px', lg: '0px' }}
            pb={{
                _: '56px',
                sm: '80px',
                md: isLoggedIn ? '80px' : '48px',
                lg: isLoggedIn ? '80px' : '64px',
            }}
            height={{ lg: '502px' }}
            overflow="hidden"
        >
            <View position="relative">
                <GridColumnWrapper
                    gridColumnSpacing={{ _: 12, md: 3, lg: 3.6 }}
                    position="absolute"
                    top={{ sm: '-390px', md: '-72px', lg: '-64px' }}
                    right={{
                        sm: 'calc(310px - 50%)',
                        md: '-108px',
                        lg: '-164px',
                    }}
                    gridAlignment="flex-end"
                >
                    <View display={{ _: 'none', lg: 'inherit' }}>
                        <AboveTheFoldLgSVG />
                    </View>
                    <View display={{ _: 'none', md: 'inherit', lg: 'none' }}>
                        <AboveTheFoldMdSVG />
                    </View>
                    <View
                        display={{ _: 'none', sm: 'inherit', md: 'none' }}
                        css={{ svg: { overflow: 'visible !important' } }}
                    >
                        <AboveTheFoldSmSVG />
                    </View>
                </GridColumnWrapper>
                <Heading
                    variant="heading2xl"
                    display={{ _: 'none', md: 'inherit' }}
                    as="h1"
                >
                    Explore content and get advice on popular career topics
                </Heading>
                <Heading
                    variant={{ _: 'headingLg', sm: 'heading2xl' }}
                    display={{ _: 'inherit', md: 'none' }}
                    as="h1"
                >
                    Explore popular career topics
                </Heading>
                <Heading
                    variant={{ _: 'headingXs', sm: 'headingSm' }}
                    pt={{ _: '16px', sm: '24px' }}
                    as="h2"
                >
                    Your biggest career questions, answered. Get advice from our
                    community of women empowering women.
                </Heading>
                {!isLoggedIn ? (
                    <AuthLoginButton onLoginPress={onLoginPress} />
                ) : null}
            </View>
        </GridColumnWrapper>
    );
};
